import React, { useState } from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import "./checkBoxHL.css";

const CheckBoxHLPure = (props) => {
  const {
    labelCheckBox, //Label to check
    valueCheckBox, //Value to check
    idCheckBox, //Id checkBox, string, number, you can use value labelCheckBox
    onChangeHandler, //Funtion to check
    checkedState, //State that change check
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
  } = props;

  const [valueCheck, setValueCheck] = useState(valueCheckBox || false);
  const handleChange = (event) => {
    setValueCheck(event.target.checked);
  };

  return (
    <div
      item
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className="checkBoxHLPure-container"
    >
      <label
        className="checkBoxHLPure-label"
        htmlFor={idCheckBox}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          className="checkBoxHLPure-input"
          {...props}
          id={idCheckBox}
          name={labelCheckBox}
          value={valueCheck}
          checked={checkedState}
          onChange={onChangeHandler ? onChangeHandler : handleChange}
        />
        <div className="checkBoxHLPure-label-text">{labelCheckBox}</div>
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </label>

    </div>
  );
};

export { CheckBoxHLPure as default };
